export const ETABehaviourConfigSettingStatus = {
    FALSE: "false",
    TRUE: "true",
    MANDATORY: "MANDATORY"
}